// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "b39168cdf53fd51a80451ac457fa82f7" + ".js";
};